import React from "react"
import { useStaticQuery, graphql } from "gatsby"
import Img from "gatsby-image"
import OurStoryPageStyle from "./our-story-page.module.scss"

/*
 * This component is built using `gatsby-image` to automatically serve optimized
 * images with lazy loading and reduced file sizes. The image is loaded using a
 * `useStaticQuery`, which allows us to load the image from directly within this
 * component, rather than having to pass the image data down from pages.
 *
 * For more information, see the docs:
 * - `gatsby-image`: https://gatsby.dev/gatsby-image
 * - `useStaticQuery`: https://www.gatsbyjs.org/docs/use-static-query/
 */

const OurStoryImgDesktop = () => {
  const data = useStaticQuery(graphql`
    query {
      contentfulOurStoryPage{
        ourStoryReference{
          hero{
            heroDesktopBgImage{
              fluid(maxWidth: 1000, quality: 100){
                ...GatsbyContentfulFluid
              }
            }
          }
        }
      }
    }
  `)

  return <Img alt="Website Design and Development Agency - First String Digital" className={OurStoryPageStyle.heroImgDesktop} fluid={data.contentfulOurStoryPage.ourStoryReference.hero.heroDesktopBgImage.fluid} />
}

export default OurStoryImgDesktop
